import { GetterTree } from "vuex";
import { IState } from "./IState";
import { SaveTrees } from "@timesheets/constants-common";
import { WebApplicationConstants } from "../setup/WebApplicationConstants";

export const getters: GetterTree<IState, IState> = {
  currentTenantSquareLogoPath(state: IState) {
    const currentTenantLogoPaths = state.logoPaths[WebApplicationConstants.currentTenant] || state.logoPaths[SaveTrees.ReservedNames[0]];

    return currentTenantLogoPaths.square;
  },
  currentTenantRectangularLogoPath(state: IState) {
    const currentTenantLogoPaths = state.logoPaths[WebApplicationConstants.currentTenant] || state.logoPaths[SaveTrees.ReservedNames[0]];

    return currentTenantLogoPaths.rectangular;
  },
};
